<template>
  <div class="mbr-container">
    <div v-if="userInfo.mobile.length == 0">
      <el-button type="primary" size="small" @click="$router.push('/login')">登录</el-button>
    </div>
    <div v-else>
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link" style="display: flex; align-items: center; cursor: pointer">
          <el-avatar :src="userInfo.avatar"> {{ userInfo.name[0] }} </el-avatar>
          <span style="color: black; margin-left: 5px">{{ userInfo.name }}</span>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'mbrInfo',
  computed: {
    ...mapGetters({
      userInfo: 'user/userInfo',
    }),
  },
  data() {
    return {}
  },
  methods: {
    handleCommand(command) {
      if (command == 'logout') this.clickLogOut()
    },
    // 退出登录
    clickLogOut() {
      this.$store
        .dispatch('user/logout')
        .then(() => {
          this.$router.push('/login')
        })
        .catch((err) => {
          console.log(err)
        })
    },
  },
}
</script>

<style scoped>
.mbr-container {
  height: 60px;
  overflow: hidden;
  display: flex;
  align-items: center;
  margin-left: 10px;
}
::v-deep .el-avatar > img {
  width: 100% !important;
}
</style>
